exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".style__name___GwSNR{font-family:PlayfairDisplay-Regular;font-size:36px;letter-spacing:2.2px;color:#333}.style__price___1BL6P{font-size:36px;text-align:left;font-family:Poppins-Light;letter-spacing:.6px;line-height:1;color:#c1887f;margin:0 auto}.style__priceHeading___3pZ8U{font-family:PlayfairDisplay-Regular;font-size:14px;letter-spacing:1px;color:#000}.style__topGrid___2TFaP{height:73px!important}.style__bottomGrid___3CzYN{height:62px!important}", ""]);

// exports
exports.locals = {
	"name": "style__name___GwSNR",
	"price": "style__price___1BL6P",
	"priceHeading": "style__priceHeading___3pZ8U",
	"topGrid": "style__topGrid___2TFaP",
	"bottomGrid": "style__bottomGrid___3CzYN"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[name]__[local]___[hash:base64:5]!./src/components/jewelry-price/style.css
// module id = 694
// module chunks = 0